import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import JobStatusChip from '@/components/tickets/JobStatusChip.vue'
import { NO_APPROVAL } from '@/models/job'
import JobCardLocationsDetail from '../jobs/JobCardLocationsDetail.vue'
import { formatTimeRange } from '@/utils/date-formatting'
import { JobJson } from '@/models/types/job-json'
import moment from 'moment'
import { priorities } from '@/utils/constants'
import { RouterLinkProps } from 'vue-router/types/router'
import { useStore } from 'vuex-composition-helpers'
import { Asset } from '@/models/asset'

type RouterLinkTo = RouterLinkProps['to']


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldViewJobCard',
  props: {
    job: null,
    linkTo: null
  },
  setup(__props: any) {

const props = __props as {
  job: JobJson
  linkTo: RouterLinkTo
}



const store = useStore()

const company = computed(() => {
  return store.getters['companies/getByChildHubId'](props.job?.hub_id)
})
const jobTitle = computed(
  () => `Job #${props.job?.number} · ${company.value?.shortCode}`
)

const priority = computed(() =>
  priorities.find((p) => p.name === props.job.priority)
)

const scheduleTime = computed(() => {
  const startTime =
    props.job.requested_start && moment.utc(props.job.requested_start).local()
  const endTime =
    props.job.requested_end && moment.utc(props.job.requested_end).local()
  return formatTimeRange(startTime, endTime)
})

const finalStatus = computed(() =>
  props.job.approval_status !== null &&
  props.job.approval_status !== NO_APPROVAL
    ? props.job.approval_status
    : props.job.status.trim()
)

const getInventoryTypeById = computed<(id: number) => Asset>(
  () => store.getters['assets/getById']
)

const inventory = computed(() => {
  return props.job.inventory_requirements.map((inv) => ({
    name: getInventoryTypeById.value(inv.inventory_type_id)?.name,
    inventoryTypeId: inv.inventory_type_id,
    inventorySubTypeName: inv.name,
    inventorySubTypeId: inv.inventory_sub_type_id,
    quantity: inv.quantity,
    pickupLocationId: inv.pickup_location_id,
    pickupLocationName: inv.pickup_location_name,
    inventoryId: 0, // Not used
    position: inv.position,
    assetConditions: [], // Not used
  }))
})

const taskText = computed(() => {
  const assignment = props.job.assigned_resource_name || 'Unassigned'
  return `${props.job.resource_type_name} · ${assignment}`
})

return { __sfc: true,props, store, company, jobTitle, priority, scheduleTime, finalStatus, getInventoryTypeById, inventory, taskText, JobStatusChip, JobCardLocationsDetail }
}

})